import { gql } from "@stadium/services/apollo-client";
import {
  fetchProductDetailServer,
  fetchProductDetailServerWithNumber,
} from "@graphql/queries/stores/products/fetch-detail/server";

export const fetchProductDetail = gql`
  ${fetchProductDetailServer}
`;

export const fetchProductDetailWithNumber = gql`
  ${fetchProductDetailServerWithNumber}
`;
